import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { OwnerResource } from "@exonn/js-sdk";

export const module: ModuleOptions<OwnerResource> = {
  resource: ResourceEnum.Owner,
  bigIcon: <span className={"icon-20-customers_lst"} />,
  smallIcon: <span className={"icon-15-customers_lst"} />,

  tabs: {
    edit: {
      getTitle: (resource) => resource.company_name,
    },
  },
};
